import React, { useState, useRef, useEffect } from "react";
import { Box, Form, Input, Button, Alert, Row, Col } from "@intech/web-ui";
import { Setores } from "./Setores";
import { RelacionamentoEntidade, WebAreaFundacaoEntidade } from "@entidades";
import { DadosPessoaisService, RelacionamentoService } from "@services";
import { MasterPage } from "@components";

export const Relacionamento: React.FC = ({ ...rest }) => {
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const [email, setEmail] = useState<string>("");
  const [assunto, setAssunto] = useState<string>("");
  const [mensagem, setMensagem] = useState<string>("");
  const [AreasFundacao, setAreasFundacao] = useState<Array<WebAreaFundacaoEntidade>>([]);
  const [AreaFundacao, setAreaFundacao] = useState<number>(0);

  const form = useRef<Form>();

  // useEffect(() => {
  //   (async () => {
  //     await criarLog(DMN_FUNCIONALIDADE.FALE_CONOSCO);
  //   })();
  // }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const dados = await DadosPessoaisService.Buscar();
        setEmail(dados.NO_EMAIL);

        const AreasFundacao = await RelacionamentoService.BuscarListaAreaFundacao();
        setAreasFundacao(AreasFundacao);
        // setAreaFundacao(AreasFundacao[0].OID_AREA_FUNDACAO);
      } catch (err) {
        const message = err["response"] ? err["response"]["data"] : err;
        setErro(message);
      }
      finally {
        setLoading(false);
      }
    })();
  }, []);

  async function enviar() {
    try {
      if (form.current.validate()) {
        setErro("");

        if (AreaFundacao === 0) {
          setErro("Obrigatório selecionar o Setor.");
          return;
        }

        const msg: RelacionamentoEntidade = {
          Email: email,
          Assunto: assunto,
          Mensagem: mensagem,
          OidAreaFundacao: AreaFundacao
        };

        const resultado = await RelacionamentoService.Enviar(msg);
        alert(resultado);

        setAssunto("");
        setMensagem("");
      }
    } catch (err) {
      const message = err["response"] ? err["response"]["data"] : err;
      setErro(message);
    }
  }

  return (
    <MasterPage {...rest}>
      {!loading && (
        <Box>
          <Form ref={form}>
            <Input
              title={"Seu e-mail"}
              value={email}
              onChange={setEmail}
              type={"email"}
              max={50}
              required
            />

            <div className={"form-group"} >
              <Row>
                <div className={"col-lg-2 col-form-label"}></div>

                <Col>
                  <Row>
                    <Col>
                      <Alert type={"info"}>{"Clique no botão abaixo para escolher o setor que deseja enviar a mensagem."}</Alert>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>

            <Setores
              setores={AreasFundacao}
              onChange={setAreaFundacao}
              oidAtivo={AreaFundacao}
            />

            <Input
              title={"Assunto"}
              value={assunto}
              onChange={setAssunto}
              max={50}
              required
            />

            <Input
              title={"Mensagem"}
              value={mensagem}
              onChange={setMensagem}
              type={"textarea"}
              max={4000}
              rows={10}
              required
            />

            <Button title={"Enviar"} type={"primary"} onClick={enviar} submit />
            <br />
            <br />

            {erro && <Alert type={"danger"}>{erro}</Alert>}
          </Form>
        </Box>
      )}
    </MasterPage>
  );
};
